import React, { useState } from 'react';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import Modal from '../../components/modal';
import Button from '../../components/Button';
import { toast } from 'react-toastify';

const AddGallery = ({ isModalOpen, setIsModalOpen, closeModal }) => {
  const [planData, setPlanData] = useState({
    image: null
  });
  const [loading, setLoader] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPlanData((prev) => ({ ...prev, image: file }));
    }
  };

  const handleRemoveImage = () => {
    setPlanData((prev) => ({ ...prev, image: null }));
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
  
    if (!planData.image) {
      toast.error('Please upload an image.');
      setLoader(false);
      return;
    }
  
    const formdata = new FormData();
    formdata.append('images', planData.image);
  
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };
  
    fetch('https://file-upload-ashen.vercel.app/api/upload', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === true) {
          const myHeaders = new Headers();
          myHeaders.append('Content-Type', 'application/json');
  
         
          const raw = JSON.stringify({
            imageUrls: data.data 
          });
  
          console.log(raw);
  
          const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
          };
  
          fetch('https://quran-backend-theta.vercel.app/v1/admin/gallery-images', requestOptions)
            .then((response) => response.text())
            .then((result) => {
              let data = JSON.parse(result);
              if (data?.success === true) {
                setLoader(false);
                window.location.reload();
                setIsModalOpen(false);
              } else {
                setLoader(false);
                toast.error(data.error);
              }
            })
            .catch((error) => {
              setLoader(false);
              toast.error(error);
            });
        } else {
          setLoader(false);
          toast.error('Error In Uploading Image...');
        }
      })
      .catch((error) => {
        setLoader(false);
        toast.error(error?.response?.data?.error);
      });
  };

  const isFormValid = () => {
    return planData.image !== null; // Check if an image is present
  };

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={closeModal} className={'rounded-md'}>
        <div className="">
          <div className="p-3 flex justify-between items-center">
            <div></div>
            <h1 className="capitalize h4 font-medium">Add Gallery</h1>
            <MdClose onClick={() => setIsModalOpen(false)} size={25} />
          </div>
          <hr />
          <div className="p-5">
            <form onSubmit={bannerSubmit}>
              <div className="flex gap-5 flex-wrap">
                {/* Image upload section */}
                <div
                  className="w-full border-dashed border-[#9E9E9E] bg-[#fafafa] border-2 rounded-lg p-4 cursor-pointer"
                  onClick={() => document.getElementById('fileInput').click()}
                >
                  <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-14 rounded-2xl">
                    <MdOutlineFileUpload size={30} className="text-primary" />
                  </div>
                  <p className="text-primary font-medium mt-3 text-center">
                    <span className="text-secondary">Click here</span> to upload or drop an Image
                  </p>
                  <input
                    id="fileInput"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                    accept="image/*" // Restrict to image files
                  />
                </div>

                {/* Image preview */}
                {planData.image && (
                  <div className="mt-4 relative">
                    <img
                      src={URL.createObjectURL(planData.image)}
                      alt="Selected"
                      className="w-full h-auto rounded-md"
                    />
                    <MdClose
                      onClick={handleRemoveImage}
                      className="absolute top-2 right-2 text-white cursor-pointer"
                      size={30}
                    />
                  </div>
                )}
              </div>

              {loading === true ? (
                <button
                  disabled
                  type="button"
                  className="bg-[#FB5722] w-full text-center mt-3 py-2.5 rounded-lg text-white uppercase font-semibold cursor-pointer"
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 me-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                  Loading...
                </button>
              ) : (
                <div className="flex justify-center pt-5">
                  <Button
                    label="Add"
                    type="submit"
                    className={`mt-3 py-2.5 w-full ${
                      !isFormValid()
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-secondary cursor-pointer'
                    } text-white uppercase font-semibold rounded-lg`}
                    disabled={!isFormValid()}
                  />
                </div>
              )}
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddGallery;
